module.exports = __webpack_public_path__ + "img/068dd43d8384827c0c3d7dff048685a84e700a28.35db7aaf.png";